import { FC, useState } from 'react'
import { UpgradePlanModal } from 'src/components/UpgradePlanModal'
import { useGetUserFeaturesQuery } from 'src/reactQuery/useGetUserFeaturesQuery'
import { EmptyState } from './EmptyState'
import classes from './adAnalysisOverview.module.scss'

export const AdAnalysisOverview: FC = () => {
  const [isUpgradeModalOpen, setIsUpgradeModalOpen] = useState(false)

  const { data: userFeatures } = useGetUserFeaturesQuery()
  const adsLibraryEnabled = userFeatures?.data?.adsLibraryEnabled ?? true
  const adsPerformanceEnabled =
    userFeatures?.data?.adsPerformanceEnabled ?? true
  // Overview is enabled if either ad library or ad performance is enabled
  const adsOverviewEnabled = adsLibraryEnabled || adsPerformanceEnabled

  return (
    <>
      {!adsOverviewEnabled && (
        <div className={classes.disabledWrapper}>
          <EmptyState
            onEnableClick={() => setIsUpgradeModalOpen(true)}
            type="disabled"
          />
        </div>
      )}
      <UpgradePlanModal
        isOpen={isUpgradeModalOpen}
        setIsOpen={setIsUpgradeModalOpen}
      />
    </>
  )
}
